import { styled } from "styled-components";

export const PageStyle = styled.div`
	width: 100%;
	height: 100vh;

	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;

	h1 {
		color: #006770;
		font-size: 50px;
		margin-bottom: 20px;
	}

	p {
		margin-bottom: 30px;
		font-size: 17px;
	}

	button {
		width: 200px;
	}
`;
